module.exports = __webpack_public_path__ + "img/SES_220411210.7b3d9c1a.jpg";